import React from 'react';

import attachment from '../../../images/attachment.svg';

import { FOHImage } from '../../ingredients';

export const FOHAttachmentIcon = (props: any) => (
  <FOHImage
    source={{ uri: attachment }}
    style={
      props && !!props.style
        ? { width: 24, height: 24, ...props.style }
        : { width: 24, height: 24 }
    }
  />
);
